import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ebb21314"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" NASA's Aqua and Terra satellites provide daily views of the entire surface of Earth. The "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://modis.gsfc.nasa.gov/",
    target: "_blank"
  }, "MODIS"),
  /*#__PURE__*/_createTextVNode(" instrument on these satellites helps scientists learn about conditions in our atmosphere and oceans. We display the calculated "),
  /*#__PURE__*/_createElementVNode("strong", null, "cloud cover fraction"),
  /*#__PURE__*/_createTextVNode("—the percentage of the sky at a given location that is covered by clouds—from MODIS (on the Aqua satellite), as provided by the NASA Near Earth Observations ("),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://neo.gsfc.nasa.gov/view.php?datasetId=MYDAL2_E_CLD_FR",
    target: "_blank"
  }, "NEO"),
  /*#__PURE__*/_createTextVNode(") website. ")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("details", { class: "faq" }, [
  /*#__PURE__*/_createElementVNode("summary", null, "What is the difference between 1-day and 8-day cloud cover maps?"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" NASA provides the cloud cover data in 1-day, 8-day (and, not included, 30-day) averages. "),
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createTextVNode("The "),
        /*#__PURE__*/_createElementVNode("strong", null, "1-day (daily)"),
        /*#__PURE__*/_createTextVNode(" data maps display historic cloud cover for each April 8"),
        /*#__PURE__*/_createElementVNode("sup", null, "th"),
        /*#__PURE__*/_createTextVNode(" from 2003 to 2023. ")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createTextVNode("The "),
        /*#__PURE__*/_createElementVNode("strong", null, "8-day"),
        /*#__PURE__*/_createTextVNode(" maps display an average of the 1-day data from April 7-14 from 2003 to 2023. ")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("p", null, " If you compare the 1-day vs. the 8-day maps, you'll notice that the 1-day maps often have more data at the extreme ends, either mostly clear or cloudy. The 8-day maps tend to have more data concentrated in the middle bins of partly cloudy or mostly cloudy. If you average together days that are clear and cloudy, you will end up with something in the middle. The 1-day maps are not subject to this \"smearing\" effect of averaging over many days of data. "),
  /*#__PURE__*/_createElementVNode("p", null, " The daily data can have gaps and processing artefacts, so the 8-day average provides a more reliable measure of the cloud cover at every location on the map. Because weather can vary considerably from hour-to-hour and day-to-day, the longer interval of the 8-day average gives us more data from which we can draw better conclusions about the possible weather conditions in a given location. ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("details", { class: "faq" }, [
  /*#__PURE__*/_createElementVNode("summary", null, "How does the percent cloud cover relate to what I might see in a weather report?"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" We group the percent cloud cover based on the "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.weather.gov/mrx/pfm_explain",
      target: "_blank"
    }, "bins"),
    /*#__PURE__*/_createTextVNode(" from the National Weather Service: "),
    /*#__PURE__*/_createElementVNode("table", null, [
      /*#__PURE__*/_createElementVNode("tbody", null, [
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("th", null, "Percentage"),
          /*#__PURE__*/_createElementVNode("th", null, "Cloud Cover")
        ]),
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, "0-25%"),
          /*#__PURE__*/_createElementVNode("td", null, "Clear")
        ]),
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, "25-50%"),
          /*#__PURE__*/_createElementVNode("td", null, "Partly Cloudy")
        ]),
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, "51-87%"),
          /*#__PURE__*/_createElementVNode("td", null, "Mostly Cloudy")
        ]),
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, "88-100%"),
          /*#__PURE__*/_createElementVNode("td", null, "Cloudy / Overcast")
        ])
      ])
    ])
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("details", { class: "faq" }, [
  /*#__PURE__*/_createElementVNode("summary", null, "Why use data from the Aqua satellite instead of Terra?"),
  /*#__PURE__*/_createElementVNode("p", null, " We use data from the Aqua satellite because its cloud cover measurements are taken in the afternoon, which corresponds better to the time of day of the April Eclipse. ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("details", { class: "faq" }, [
  /*#__PURE__*/_createElementVNode("summary", null, "Why is 2022 missing from the year list?"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Sometimes satellites go offline, or there are issues transmitting data back to Earth. On March 31, 2022 the Aqua satellite entered SAFE mode, only returning to normal operations on April 17, 2022. No cloud cover data is available from Mar 31 - Apr 16, 2022. View the event "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://mcst.gsfc.nasa.gov/news/aqua-safe-mode-event",
      target: "_blank"
    }, "summary"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("details", { class: "faq" }, [
  /*#__PURE__*/_createElementVNode("summary", null, "Why are 30-day maps not available?"),
  /*#__PURE__*/_createElementVNode("p", null, " MODIS offers month-long averages of the data, but we opted not to include that here to improve performance and data load times. ")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " You might be familiar with the terms mean and median from math and science classes, but it helps to see them applied in real life, to get a better feel for what they really mean and how they are helpful. ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("details", { class: "faq" }, [
  /*#__PURE__*/_createElementVNode("summary", null, "What is a mean?"),
  /*#__PURE__*/_createElementVNode("p", null, " The mean is the average of all values in the dataset. It is calculated by adding all the values together and dividing by the number of values. This is the statistical term people are probably more familiar with and is often interpreted as a single value that “best” represents an entire data set. ")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("details", { class: "faq" }, [
  /*#__PURE__*/_createElementVNode("summary", null, "What is a median?"),
  /*#__PURE__*/_createElementVNode("p", null, " The median is the middle of the dataset. Half of the data is above the median and half is less than or equal to the median. The median encourages thinking in terms of probability. You could say that given the historical cloud data over the last 20 years, there is a 50-50 chance the cloud cover will be higher or lower than the median value. ")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("details", { class: "faq" }, [
  /*#__PURE__*/_createElementVNode("summary", null, "How are these statistics applied in the Cloud Data Explorer?"),
  /*#__PURE__*/_createElementVNode("p", null, " These quantities are calculated and displayed for every location shown on the map, depending on your selections in the dropdown menus. "),
  /*#__PURE__*/_createElementVNode("p", null, " When you choose a specific location on the map, the mean and median of the cloud cover amounts are displayed for that location over the selected range of years. You can also display cloud cover values for a single year at a time. ")
], -1))
const _hoisted_11 = { class: "faq" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " The left hand graph is called a histogram. For your selected location, it tells you how many years since 2003 were Clear, Partly Cloudy, Mostly Cloudy, or Cloudy at this location. If you have filtered the data by El Niño, Neutral, or La Niña years, your chosen subset will be colored with the blue to white gradient, while the rest of the years will appear gray. ", -1))
const _hoisted_13 = { class: "faq" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " The right hand graph is a scatter plot showing the cloud cover for your chosen location for each year since 2003. If you have filtered the data by El Niño, Neutral, or La Niña years, or for a single year, those data points will be displayed in yellow. The background of the graph shows what cloud cover values correspond to the weather conditions of Clear, Partly Cloudy, etc. ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" You might have heard the terms "),
  /*#__PURE__*/_createElementVNode("strong", null, "El Niño"),
  /*#__PURE__*/_createTextVNode(" or "),
  /*#__PURE__*/_createElementVNode("strong", null, "La Niña"),
  /*#__PURE__*/_createTextVNode(". They refer to weather patterns that are associated with a slight warming (“El Niño”) or cooling (“La Niña”) of the surface water in the Pacific Ocean relative to normal (“Neutral”). These are part of what is called the El Niño Southern Oscillation (ENSO) cycle. These different conditions can impact weather worldwide, so we provide the option of filtering the historical cloud data based on these classifications. "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://oceanservice.noaa.gov/facts/ninonina.html",
    target: "_blank"
  }, "Learn more"),
  /*#__PURE__*/_createTextVNode(" about these fascinating weather phenomena from the NOAA National Ocean Service. ")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("details", { class: "faq" }, [
  /*#__PURE__*/_createElementVNode("summary", null, " What years are considered El Niño, La Niña, or Neutral?"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" We use NOAA's "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://psl.noaa.gov/enso/past_events.html",
      target: "_blank"
    }, "list"),
    /*#__PURE__*/_createTextVNode(" of past ENSO events to classify years as El Niño, La Niña, or Neutral. As that page explains, there is not a single accepted way to define which of these categories we are in. Their list is based on the presence of an active El Niño or La Niña pattern during the months of December, January, and February. As an ENSO typically last several months (or even years), this provides a decent indication a how likely April is to have the same pattern. ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" For the years included in our data set, they classify them as follows: "),
    /*#__PURE__*/_createElementVNode("table", null, [
      /*#__PURE__*/_createElementVNode("tbody", null, [
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("strong", null, "El Niño"),
            /*#__PURE__*/_createTextVNode(": ")
          ]),
          /*#__PURE__*/_createElementVNode("td", null, "2003, 2007, 2010, 2016")
        ]),
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("strong", null, "Neutral"),
            /*#__PURE__*/_createTextVNode(": ")
          ]),
          /*#__PURE__*/_createElementVNode("td", null, "2004, 2005, 2006, 2009, 2013, 2014, 2015, 2017, 2018")
        ]),
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("strong", null, "La Niña"),
            /*#__PURE__*/_createTextVNode(": ")
          ]),
          /*#__PURE__*/_createElementVNode("td", null, "2008, 2011, 2012, 2021, 2022, 2023")
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" If you want to see what the ENSO conditions were in March/April in the past, see the \"MEI.v2 Values\" at this NOAA "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://psl.noaa.gov/enso/mei/",
      target: "_blank"
    }, "website"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("details", { class: "faq" }, [
  /*#__PURE__*/_createElementVNode("summary", null, "What kind of year is 2024?"),
  /*#__PURE__*/_createTextVNode(" As of early 2024, we are in an El Niño pattern. The Climate Prediction Center of the National Weather Service "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.cpc.ncep.noaa.gov/products/analysis_monitoring/enso_advisory/ensodisc.shtml",
    target: "_blank"
  }, "reports"),
  /*#__PURE__*/_createTextVNode(" an 83% chance that we will transition to a "),
  /*#__PURE__*/_createElementVNode("em", null, "neutral"),
  /*#__PURE__*/_createTextVNode(" pattern some time from April - June. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    id: "cloud-data-explainer",
    modelValue: _ctx.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.value) = $event)),
    "close-on-back": "",
    "close-on-esc": "",
    scrollable: "",
    fullscreen: _ctx.fullscreen
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "align-self-center",
        "max-height": "80%",
        height: "500px",
        "max-width": "90%",
        "min-width": "90%"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_tabs, {
                "selected-class": "selected-tab",
                height: "1.5rem",
                modelValue: _ctx.tab,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
                direction: _ctx.$vuetify.display.width < 765 ? 'vertical' : 'horizontal'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tab, {
                    class: "no-text-transform",
                    value: "cloud-data"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("About Cloud Cover Data")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tab, {
                    class: "no-text-transform",
                    value: "stats"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Statistical Concepts")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tab, {
                    class: "no-text-transform",
                    value: "weather"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Weather Patterns")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "direction"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_window, {
                modelValue: _ctx.tab,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_window_item, { value: "cloud-data" }, {
                    default: _withCtx(() => [
                      _hoisted_1,
                      _hoisted_2,
                      _hoisted_3,
                      _hoisted_4,
                      _hoisted_5,
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, { value: "stats" }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _hoisted_8,
                      _hoisted_9,
                      _hoisted_10,
                      _createElementVNode("details", _hoisted_11, [
                        _createElementVNode("summary", null, [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-chart-bar")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" What is in the chart on the " + _toDisplayString(_ctx.smAndUp ? 'left' : 'top') + "?", 1)
                        ]),
                        _hoisted_12
                      ]),
                      _createElementVNode("details", _hoisted_13, [
                        _createElementVNode("summary", null, [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-chart-scatter-plot")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" What is in the graph on the " + _toDisplayString(_ctx.smAndUp ? 'right' : 'bottom') + "?", 1)
                        ]),
                        _hoisted_14
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, { value: "weather" }, {
                    default: _withCtx(() => [
                      _hoisted_15,
                      _hoisted_16,
                      _hoisted_17
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "#eac402",
                variant: "flat",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.value = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Close")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "fullscreen"]))
}